import { CHAINS } from "@/types/highlights"
import Button from "./Button"

import { useNetwork, useSwitchNetwork } from "wagmi"
import { getChainId } from "@/util/crypto"

export default function SwitchChainButton(props: { chain: CHAINS }) {
  const network = useNetwork()
  const chains = useSwitchNetwork({
    chainId: getChainId(props.chain),
  })
  const onRightChain = network.chain?.id === getChainId(props.chain)

  console.log(
    "Are we on the right chain?",
    onRightChain,
    network.chain,
    props.chain
  )

  if (onRightChain) return null

  return (
    <div className="mt-3">
      <Button
        type="button"
        text="Switch chains"
        onClick={() => {
          chains?.switchNetwork?.(getChainId(props.chain))
        }}
      />
    </div>
  )
}
